export default {
  install(app, options = {}) {
    const defaultOpts = {
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
      ...options,
    };

    const toast = (type, message, opts = {}) => {
      const icon =
        type === "success" ? "success" :
        type === "warning" ? "warning" :
        type === "info"    ? "info" :
        "error";

      const root = document.documentElement;
      const isDark = root.classList.contains("dark") && !root.classList.contains("light");

      const css = getComputedStyle(root);
      const primary = css.getPropertyValue("--primary").trim() || "#2B6EF5";
      const darkPrimary = css.getPropertyValue("--dark-primary").trim() || "#0E1C3F";

      const background = isDark ? darkPrimary : "#ffffff";
      const color = isDark ? "#ffffff" : "#111518";

      const swal = app.config.globalProperties.$swal;

      if (swal?.fire) {
        return swal.fire({
          ...defaultOpts,
          confirmButtonColor: primary,
          background,
          color,
          ...opts,
          icon,
          title: message,
        });
      }

      console[type === "success" ? "log" : "error"](message);
    };

    app.config.globalProperties.$toast = toast;
    app.provide("toast", toast);
  },
};
